import clsx from 'clsx';
import type * as React from 'react';

import { useFieldContext } from './FieldContext';

export type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement> & {
    /**
     * Remove any styling from the label.
     */
    headless?: boolean;
};

/**
 * Label for a field.
 * @example
 * <Label>Title</Label>
 */
export function Label({ className, htmlFor, id: propId, headless, ...props }: LabelProps) {
    const ctx = useFieldContext();
    return (
        <label
            id={propId ?? ctx?.labelId}
            className={clsx(
                'peer/label peer/descriptor',
                !headless && 'text-ui-heading-small',
                className
            )}
            htmlFor={htmlFor ?? ctx?.controlId}
            {...props}
        />
    );
}
